import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IdName } from '@api/models/idname';

@Component({
  selector: 'flow-booking-item',
  templateUrl: './booking-item.component.html',
  styleUrls: ['./booking-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingItemComponent {
  @Input() item: IdName;
  @Input() pastDay: boolean = false;
}
